import { createFileRoute } from "@tanstack/react-router";

import AddAccount2 from "@/features/onboarding/AddAccount2";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/_auth-basic/add-account-2")({
  component: () => (
    <BasicLayout>
      <AddAccount2 />
    </BasicLayout>
  ),
});
